var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfigPage',[_c('ConfigItem',{attrs:{"title":_vm.__('Distribuição automática', 'settings'),"description":_vm.__(
        'O parâmetro define se o sistema deve sugerir automaticamente a unidade quando a lead é criada',
        'settings'
      )}},[_c('v-card',{staticClass:"mx-4",attrs:{"outlined":""}},[_c('v-card-text',[_c('v-switch',{attrs:{"label":_vm.__('Ativar distribuição automática', 'settings')},on:{"change":_vm.handleUpdateEnabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }